import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer>
      <div className="footer-sample-bar">
        <div className="sample-text">
          <h3>Would you like to receive <span>consultation</span> from Industry Max?</h3>
          <p>We’re here to support your business with reliable and secure technology infrastructure. Contact us today!</p>
        </div>
        <div className="footer-buttons">
          <a href="/contact-us/" className="btn-sample">Request Consultation</a>
          <a href="/contact-us/" className="btn-message">Send A Message</a>
        </div>
      </div>

      <div className="footer-main">
        <div className="footer-col solutions-links">
          <h4>SOLUTIONS</h4>
          <ul>
            <li><a href="/solutions/?category=Fire%20Systems">Fire Systems</a></li>
            <li><a href="/solutions/?category=Communication%20Systems">Communication Systems</a></li>
            <li><a href="/solutions/?category=Power%20Solutions">Power Solutions</a></li>
            <li><a href="/solutions/?category=Automation%20Solutions">Automation Solutions</a></li>
            <li><a href="/solutions/?category=Facility%20Management">Facility Management</a></li>
            <li><a href="/solutions/?category=Security%20Systems">Security Systems</a></li>
            <li><a href="/solutions/?category=Data%20Centers">Data Centers</a></li>
            <li><a href="/solutions/?category=Networking%20Solutions">Networking Solutions</a></li>
            <li><a className="btn-sample" href="/solutions/">View All Solutions</a></li>
          </ul>
        </div>
       
    






        <div className="footer-col quick-links">
          <h4>QUICK LINKS</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/solutions/">Solutions</a></li>
            <li><a href="/#products-title-html">Products</a></li>
            <li><a href="/#about-title-html">About Industry Max</a></li>
            <li><a href="/#why-title-html">Services</a></li>
            <li><a href="/#partners-title-html">Partners</a></li>
            <li><a href="/#news-title-html">News</a></li>
            <li><a href="/faq/">Faq</a></li>
            <li><a href="/contact-us/">Contact Us</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <div className="footer-logo">
            <h2>INDUSTRY MAX</h2>
            <p>Industry Max Technology Solutions</p>
          </div>
          <div className="footer-contact">
            <p>📞 Tel: +971 586 686 710</p>
            <p>📧 Info: <span style={{ textTransform: "none" }}>info@industry-max.ae</span></p>
             <p>📧 Sales: <span style={{ textTransform: "none" }}>sales@industry-max.ae</span></p>
            <p>📍 Address: Meydan Free Zone, Dubai, UAE</p>
          </div>
        {/*
         <div className="social-icons">
            <a href="#" target="_blank" rel="nofollow">🔵</a>
            <a href="#" target="_blank" rel="nofollow">🔴</a>
            <a href="#" target="_blank" rel="nofollow">▶️</a>
            <a href="#" target="_blank" rel="nofollow">💬</a>
            <a href="#" target="_blank" rel="nofollow">🟢</a>
          </div>
        */} 
         
        </div>
      </div>

      <div className="footer-bottom">
        Copyright © 2026 IT Solutions & Security Systems Provider - Industry Max. 
        All Rights Reserved. Unauthorized reproduction of this website is strictly prohibited, 
        and any unauthorized use will be prosecuted.
      </div>
    </footer>
  );
};

export default Footer;
